import { OrganizationApi } from '../../../api';
import { RootState, dispatch } from '../../../store';
import { useContainer } from '../../useContainer';
import { useEffect, useState } from 'react';
import { setOrganization as setOrganizationSlice } from '../../../store/slices/organization.slice';
import { useSelector } from 'react-redux';
import { selectOrganization } from '../../../store/slices/organization.slice';

const useHttpGetOrganizationByIdOnMount = (organizationId: string) => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const organization = useSelector((state: RootState) => selectOrganization(state));
    const isOrganizationCached = organization.organizationId === organizationId && Boolean(organization.name);
    const [isOrganizationReady, setIsOrganizationReady] = useState<boolean>(isOrganizationCached);

    useEffect(() => {
        if (!organizationId) {
            return;
        }

        if (isOrganizationCached) {
            setIsOrganizationReady(true);
            return;
        }

        const { exec } = organizationApi.getOrganizationById({
            params: { organizationId },
            onSuccess: res => dispatch(setOrganizationSlice(res.body)),
            onError: error => error,
            onFinally: () => setIsOrganizationReady(true),
        });

        setIsOrganizationReady(false);
        exec();
    }, [organizationId, isOrganizationCached]);

    return { isOrganizationReady };
};

export default useHttpGetOrganizationByIdOnMount;
